import c3 from "./images/c3.jfif";
import c4 from "./images/c4.png";
import c5 from "./images/c5.jfif";

export const carouselData = [
  {
    src: c3,
    title: "Unbiased Product Recommendations",
    content: "Designed to help, not to sell",
    buttonText: "Say Goodbye To Debt",
  },
  {
    src: c4,
    title: "Hand-picked debt consolidation solutions",
    content: "Tailored to your needs",
    buttonText: "Find Your Match",
  },
  {
    src: c5,
    title: "Customized debt payoff plans",
    content: "Built to get you out of debt",
    buttonText: "Get Your Plan",
  },
];
